var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTegetaHoldingLogoEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 693 245",
    style: {
      enableBackground: "new 0 0 693 245"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#35393C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "118.72,62.97 16.21,62.97 16.21,91.38 53.26,91.38 53.26,182.03 81.67,182.03 81.67,91.38  118.72,91.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "230.05,91.38 230.05,62.97 136.68,62.97 136.68,182.03 230.05,182.03 230.05,153.63 165.09,153.63  165.09,136.34 212.27,136.34 212.27,107.93 165.09,107.93 165.09,91.38  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.68,116.58h50.89v20.25c0,35.32-21.24,47.43-47.43,47.43h-6.91c-26.19,0-47.67-11.85-47.67-47.43v-28.65 c0-35.56,21.49-47.43,47.67-47.43h6.91c25.69,0,46.69,11.61,47.43,45.71h-28.91c-1.48-12.6-6.41-17.3-18.52-17.3h-6.91 c-14.83,0-19.28,6.92-19.28,26.69v13.34c0,19.76,4.45,26.67,19.28,26.67h6.91c10.8,0,15.96-3.68,17.96-13.34h-21.42V116.58z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "461.02,91.38 461.02,62.97 367.65,62.97 367.65,182.03 461.02,182.03 461.02,153.63 396.06,153.63  396.06,136.34 443.24,136.34 443.24,107.93 396.06,107.93 396.06,91.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "576.36,62.97 473.85,62.97 473.85,91.38 510.9,91.38 510.9,182.03 539.31,182.03 539.31,91.38  576.36,91.38  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M639.01,62.98h-37.74l-37.8,119.05h29.65l5.27-16.58l43.46-0.16l5.32,16.74h29.64L639.01,62.98z  M606.95,138.44l13.19-41.53l13.12,41.33L606.95,138.44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTegetaHoldingLogoEn);
export default __webpack_public_path__ + "static/media/tegeta_holding_logo_en.c15fe652a8e7bd15832a4cab85588db4.svg";
export { ForwardRef as ReactComponent };